import React, { CSSProperties } from 'react';
import buttonStyles from './cta.module.scss';
import { ButtonStyleType } from '../../../constants/button-style-type';
import colorStyle from '../../../styles/utils/variables.module.scss';
import Button from '../../atoms/button/button';
import RichText from '../../atoms/rich-text/rich-text';
import IRichText from '../../../models/viewModels/base/IRichText';
import IButton from '../../../models/button/IButton';
import { ApplicationSettings } from '../../../models/settings';

export type CtaProps = {
  ctaID?: string;
  textColor?: string;
  wrapperBorderColor?: string;
  wrapperBackgroundColor?: string;
  url?: string;
  /** added button style and type string literals to specify exact values,
   * with a union type to join them together */
  text: IRichText;
  buttons: IButton[];
  appSettings?: ApplicationSettings;
};

const CtaWrapper = ({
  className,
  children,
  href,
  id,
  textColor,
  borderColor,
  backgroundColor,
}: any) => {
  const wrapperStyle: CSSProperties = {
    backgroundColor: backgroundColor,
    borderColor: borderColor,
    color: textColor || colorStyle.white,
    cursor: href ? 'pointer' : 'default',
  };

  if (href) {
    return (
      <a id={id} className={className} style={wrapperStyle} href={href} rel={'noreferrer'}>
        {children}
      </a>
    );
  }

  return (
    <div id={id} className={className} style={wrapperStyle}>
      {children}
    </div>
  );
};

export default function Cta({
  ctaID,
  textColor,
  wrapperBorderColor,
  wrapperBackgroundColor,
  /** added button style and type string literals to specify exact values,
   * with a union type to join them together */
  text,
  url,
  buttons,
  appSettings,
}: CtaProps) {
  return (
    <>
      <CtaWrapper
        id={ctaID}
        className={`${buttonStyles.cta}`}
        textColor={textColor}
        borderColor={wrapperBorderColor}
        backgroundColor={wrapperBackgroundColor}
        href={url}
      >
        <div className={`${buttonStyles.textContainer}`}>
          <RichText richText={text} />
        </div>
        {!url ? (
          <div className={`${buttonStyles.buttonContainer}`}>
            {buttons?.map((button) => (
              <Button
                key={button.buttonName}
                buttonID={button.buttonID}
                buttonURL={button.buttonURL}
                buttonAriaLabel={button.buttonAriaLabel}
                buttonName={button.buttonName}
                buttonNewTab={button.buttonNewTab}
                buttonStyle={button.buttonStyle}
                buttonSize={button.buttonSize}
                copyColor={
                  button.buttonStyle === ButtonStyleType.Outline
                    ? appSettings.branding.primaryColor
                    : colorStyle.white
                }
                backgroundColor={
                  button.buttonStyle === ButtonStyleType.Outline
                    ? colorStyle.white
                    : appSettings.branding.primaryColor
                }
                outlineColor={appSettings.branding.primaryColor}
                hoverBackgroundColor={appSettings.branding.primaryHoverColor}
                activeBackgroundColor={appSettings.branding.primaryActiveColor}
                heapIdentifier={button.buttonID}
              >
                {button.children}
              </Button>
            ))}
          </div>
        ) : null}
      </CtaWrapper>
    </>
  );
}
